import { useTranslation } from 'react-i18next';
import { useFormContext, useController } from 'react-hook-form';
import { FormField, Input } from '@veo/web-design-system';
import { isRequiredValidator } from 'src/common/utils/form-validators';
import { AboutInfoFormValues } from '../../../utils/about-information';
import styles from './about-information-form.module.scss';

export function FirstnameField() {
  const { t } = useTranslation();

  const { control, register } = useFormContext<AboutInfoFormValues>();

  const { fieldState } = useController<AboutInfoFormValues, 'firstName'>({
    control,
    name: 'firstName',
    rules: {
      validate: (v) => isRequiredValidator(v),
    },
  });

  const {
    isTouched,
    error,
  } = fieldState;

  return (
    <FormField
      className={styles.field__small}
      label={t('player_about.form.firstname_field_label')}
      id="firstName"
      error={isTouched ? error?.message : undefined}
    >
      <Input
        type="text"
        {...register('firstName')}
      />
    </FormField>
  );
}
